"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettifyQuery = exports.isCorrectQuery = exports["default"] = void 0;
var _standalone = _interopRequireDefault(require("prettier/standalone"));
var _parserGraphql = _interopRequireDefault(require("prettier/parser-graphql"));
var _helpers = require("./helpers.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var prettify = function prettify(code) {
  return _standalone["default"].format(code, {
    parser: 'graphql',
    plugins: [_parserGraphql["default"]]
  });
};
var prettifyQuery = exports.prettifyQuery = function prettifyQuery(query) {
  if (!query || !query.includes('{')) {
    return query;
  }
  var result = prettify("query { ".concat(query, " }")).split('\n').filter(function (str) {
    return str;
  }).slice(1, -1).map(function (str) {
    return str.replace(/^\s{2}/g, '');
  }).join('\n');
  return result;
};
var isCorrectQuery = exports.isCorrectQuery = function isCorrectQuery(query) {
  if (!query) {
    return false;
  }
  try {
    if (query.includes('{') || query.includes('[')) {
      query = prettify("query { ".concat(query, " }"));
    }
    query = (0, _helpers.getPathFromQuery)(query);
  } catch (e) {
    return false;
  }
  return /^(\w+\.)*\w+$/.test(query);
};
var _default = exports["default"] = prettify;